import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import {connect} from 'react-redux';
import {Segment} from 'semantic-ui-react';

import {graphql} from 'react-apollo';
import {GetUserSettingsForHeader} from '@graphql/user/query';
import {setTimezone} from '@actions';
import PathValidator from '@appComponents/PathValidator';
import Time from '@appComponents/HeaderComponents/Time.jsx';
import User from '@appComponents/HeaderComponents/User.jsx';
import Timezone from '@appComponents/HeaderComponents/Timezone.jsx';

/**
 * @ignore
 */
class Header extends React.Component {
    static propTypes = {
        data: PropTypes.object,
        location: PropTypes.object.isRequired,
        setTimezone: PropTypes.func.isRequired,
    };

    static defaultProps = {
        data: {},
    };

    state = {
        timezone: '',
        autodetected_timezone: '',
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { userSettings } = nextProps.data;

        if (userSettings) {
            const { timezone, autodetected_timezone } = userSettings;

            if (
                timezone !== prevState.timezone ||
                autodetected_timezone !== prevState.autodetected_timezone
            ) {
                return {
                    timezone,
                    autodetected_timezone,
                };
            }
        }

        return null;
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.timezone !== prevState.timezone ||
            this.state.autodetected_timezone !== prevState.autodetected_timezone
        ) {
            this.props.setTimezone({
                timezone: this.state.timezone,
                autodetected_timezone: this.state.autodetected_timezone,
            });
        }
    }

    render() {
        if (!this.props.data?.userSettings) {
            return null;
        }

        const {userSettings} = this.props.data;
        const timezone = this.state.timezone || this.state.autodetected_timezone || 'UTC';

        return (
            <Segment basic className='page-header'>
                <div className='page-header__breadcrumb'>
                    <PathValidator pathname={this.props.location.pathname}/>
                </div>
                <div className='page-header__widgets'>
                    <Time timezone={timezone}/>
                    <Timezone timezone={timezone}/>
                    <User name={(userSettings?.name) ? userSettings.name : '..'}/>
                </div>
            </Segment>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return ({
        setTimezone: (timezone) => {
            dispatch(setTimezone(timezone));
        },
    });
};

const HeaderWithQuery = graphql(GetUserSettingsForHeader)(Header);

export default withRouter(connect(null, mapDispatchToProps)(HeaderWithQuery));
